import React from 'react';

const VideoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.938" height="12.172" viewBox="0 0 17.938 12.172">
      <g transform="translate(0.5 0.5)">
        <g transform="translate(0 0)">
          <g transform="translate(0 0)">
            <path d="M9.833,1H2.043A2.217,2.217,0,0,0,0,3.336v6.5a2.217,2.217,0,0,0,2.043,2.336h7.79a2.218,2.218,0,0,0,2.04-2.336v-6.5a2.508,2.508,0,0,0-.6-1.653A1.915,1.915,0,0,0,9.833,1Zm5.593.674a.976.976,0,0,0-.348.168l-3.188,2.1v5.42l3.208,2.1a1.084,1.084,0,0,0,.932.146,1.254,1.254,0,0,0,.744-.659,1.589,1.589,0,0,0,.163-.7V3.033a1.487,1.487,0,0,0-.47-1.1,1.113,1.113,0,0,0-1.042-.263Z" transform="translate(0 -1)" fill="none" stroke="currentColor" strokeWidth="1"/>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default VideoIcon;
